import { useStoryblokRichText } from '@storyblok/react'
import { type ReactNode } from 'react'

import { type StoryblokRichTextDoc } from './storyblok'

/**
 * A helper hook to cover the Storyblok TypeScript type incompatability between `@storyblok/react` and `@storyblok/richtext`.
 *
 * Usage of `StoryblokRichText` is not recommended. The component wraps the content in a non-customizable `<div />` element breaking `.prose` functionality.
 */
export const useCmsRichTextRender = (): ((
  document: StoryblokRichTextDoc,
) => ReactNode) => useStoryblokRichText()
